import { axiosInstanceWeb, axiosInstanceWebV2 } from './web.axios.instance';
import axiosInstance from './axios.instance';

// launch bar
export const API_ADD_WEB_LAUNCHBAR = (postBody) => axiosInstanceWeb.post('/launchers', postBody);

export const API_GET_WEB_LAUNCHBAR = (launchbarId) =>
  axiosInstanceWeb.get(`/launchers/${launchbarId}`);

export const API_GET_ALL_WEB_LAUNCHBAR = () => axiosInstanceWeb.get(`/launchers`);

export const API_UPDATE_WEB_LAUNCHBAR = (postBody, launchbarId) =>
  axiosInstanceWeb.put(`/launchers/${launchbarId}`, postBody);

export const API_DELETE_WEB_LAUNCHBAR = (launchbarId) =>
  axiosInstanceWeb.delete(`/launchers/${launchbarId}`);

export const API_PUBLISH_WEB_LAUNCHBAR = (launchbarId, postBody) =>
  axiosInstanceWeb.post(`/launchers/${launchbarId}/publish`, postBody);

export const API_UNPUBLISH_WEB_LAUNCHBAR = (launchbarId) =>
  axiosInstanceWeb.post(`/launchers/${launchbarId}/unpublish`);

export const API_UPDATE_LAUNCHBAR_TEAM_ASSIGNMENT = (launcherID, postBody) =>
  axiosInstanceWeb.put(`/launchers/${launcherID}/teams`, postBody);

export const API_GET_WEB_TEAMS_LAUNCHBAR = () => axiosInstanceWeb.get(`/launcher-teams`);

export const API_GET_WEB_TEAMS_LAUNCHBAR_V2 = () => axiosInstanceWebV2.get(`/launcher-teams`);

// /widget/quicklauncher/metadata
export const API_GET_WEB_LAUNCHBAR_METADATA = () =>
  axiosInstance.get(`/widget/quicklauncher/metadata?application=web`);

export const API_CLONE_LAUNCHBAR = (launcherId) =>
  axiosInstanceWeb.post(`/launchers/${launcherId}/clone`);

export const API_WEB_UPLOAD_URL = (data) => axiosInstanceWeb.get(`/widgets/uploadUrl?${data}`);
